var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-background-light layout"},[(_vm.renderNavBar)?_c('NavBar'):_vm._e(),_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }